"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExperiment = useExperiment;
exports.useFeatureFlag = useFeatureFlag;
const utils_1 = require("../utils");
const context_1 = require("../context");
function useExperiment(flagKey) {
    const { experiments, flagOverrides } = (0, context_1.useLaunchDarklyData)();
    return (0, utils_1.getExperiment)(experiments, flagKey, flagOverrides);
}
function useFeatureFlag(flagKey) {
    const { featureFlags, flagOverrides } = (0, context_1.useLaunchDarklyData)();
    return (0, utils_1.getFeatureFlag)(featureFlags, flagKey, flagOverrides);
}
//# sourceMappingURL=hooks.js.map